import styled, { css } from 'styled-components';
import { Headline3 } from './../../app/common/typography';

export const AccordionContainer = styled.div`
  border-radius: ${({ theme }) => theme.radius.xs};
  background: ${({ theme }) => theme.colors.white};
  box-shadow:
    0px 1.6px 3.6px 0px rgba(0, 0, 0, 0.13),
    0px 0.3px 0.9px 0px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${({ theme }) => theme.spacing.m};
  margin-bottom: ${({ theme }) => theme.spacing.l};
  font-size: 22px;
  font-weight: ${({ theme }) => theme.fontWeight.semiBold};
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: ${({ theme }) => theme.width.full};
  row-gap: ${({ theme }) => theme.spacing.m};
  margin-bottom: 20px;
  & svg.calendarIcon {
    width: 20px;
    height: 20px;
  }
  & svg.calendarIcon g path {
    stroke: ${({ theme }) => theme.colors.dimGray};
  }
  & .calendarIconContainer {
    top: 50%;
    transform: translateY(-50%);
  }
  & .cv-select .control-select-inner {
    border: 1px solid ${({ theme }) => theme.colors.platinum};
    border-radius: ${({ theme }) => theme.radius.xs};
    padding: ${({ theme }) => theme.spacing.s} 0;
    box-shadow: unset;
    font-size: ${({ theme }) => theme.fontSize.l};
    color: grey;
    height: 40px;
  }
  & .cv-select.has-value .control-select-inner {
    height: 56px;
    padding: ${({ theme }) => theme.spacing.s} 0 0;
  }
  & .cv-select.has-value .control-select-select {
    margin-top: ${({ theme }) => theme.spacing.xs};
  }
  & .cv-select .control-select-inner .control-select-select.has-placeholder {
    font-size: ${({ theme }) => theme.fontSize.l};
    color: grey;
  }
  & .cv-select.hasError .control-select-inner {
    box-shadow: inset 0 0 0 1px rgba(204, 48, 68, 0.3) !important;
    background-color: rgba(204, 48, 68, 0.07);
    border: unset;
  }
  & .cv-select .control-select-inner {
    box-shadow: unset !important;
  }
  & .cv-select.control-select.disabled .control-select-inner {
    color: rgba(51, 51, 51, 0.5);
  }
  & .cv-select.control-select .bp3-popover-dismiss-override {
    display: none;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 88px ${({ theme }) => theme.spacing.m};
`;

export const Content = styled.div`
  margin: ${({ theme }) => theme.spacing.m} ${({ theme }) => theme.spacing.none};
`;

export const SubTitle = styled(Headline3)`
  padding-bottom: ${({ theme }) => theme.spacing.md};
`;

export const InputContainer = styled.div`
  position: relative;
`;

export const InputText = styled.label(
  ({ theme, hasValue }) => css`
    position: absolute;
    font-size: ${hasValue ? theme.fontSize.xs : theme.fontSize.m};
    z-index: 1;
    top: ${hasValue ? '10px' : '18px'};
    left: 12px;
    color: ${theme.colors.battleShipGray};
    transition: all 0.3s;
  `
);
